import { History } from 'history';
import { ThunkAction } from 'redux-thunk';
import { Action, Dispatch, ActionCreator } from 'redux';

import { AppState } from '../index';

import { fetchCompanies as fetch, create } from '../../services/register';
import { authenticationAttempt } from '../user/actions';

import { ActionTypes, Action as FetchAction } from './types';
import { SngpcRegister } from '../../interfaces/sngpc';
import { AuthenticationSngpcData } from '../../interfaces/authentication';

export const fetchCompanies =
  (data: AuthenticationSngpcData) =>
    async (dispatch: Dispatch<FetchAction>): Promise<void> => {
      const { email, password } = data;

      dispatch({
        type: ActionTypes.FETCH_COMPANIES,
      });

      try {
        const response = await fetch({ email, password });

        dispatch({
          type: ActionTypes.FETCH_COMPANIES_SUCCESS,
          payload: response,
        });
      } catch (e: any) {
        const error = e?.response?.data?.issue?.length > 0 ? e?.response?.data?.issue[0]?.details?.text : e?.message;
        // eslint-disable-next-line no-console
        console.error(ActionTypes.FETCH_COMPANIES_ERROR, e)
        dispatch({
          type: ActionTypes.FETCH_COMPANIES_ERROR,
          payload: {
            error,
          },
        });
      }
    };

export const createUser =
  (data: SngpcRegister, history: History) =>
    async (dispatch: Dispatch<FetchAction | any>): Promise<void> => {
      dispatch({
        type: ActionTypes.CREATE_USER,
      });

      try {
        await create(data);

        dispatch(authenticationAttempt(data.credentials.email, data.credentials.password, history));

        dispatch({
          type: ActionTypes.CREATE_USER_SUCCESS,
        });
      } catch (e: any) {
        const error = e?.response?.data?.error || e?.message;
        
        // eslint-disable-next-line no-console
        console.error(ActionTypes.CREATE_USER_ERROR, e)

        dispatch({
          type: ActionTypes.CREATE_USER_ERROR,
          payload: {
            error,
          },
        });
      }
    };

export const resetState: ActionCreator<ThunkAction<void, AppState, null, Action<FetchAction>>> =
  () =>
    (dispatch: Dispatch<FetchAction>): void => {
      dispatch({
        type: ActionTypes.RESET_STATE,
      });
    };
